import { Suspense } from "react";
import LinearLoader from "./components/common/LinearLoader";

export const LazyLoader = ({ children, fallback = null }) => {
  return <Suspense fallback={fallback ? fallback : <LinearLoader />}>{children}</Suspense>;
};
